const routes = [
    {
        path: "/payment/approval/exceptions",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "paymentapprovalexception_index"
        }
    }
];

export default routes;
